import { render, staticRenderFns } from "./electric-charge-add.vue?vue&type=template&id=63d5e5a1&scoped=true&"
import script from "./electric-charge-add.vue?vue&type=script&lang=js&"
export * from "./electric-charge-add.vue?vue&type=script&lang=js&"
import style0 from "./electric-charge-add.vue?vue&type=style&index=0&id=63d5e5a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d5e5a1",
  null
  
)

export default component.exports